import React from 'react';
import {KeolisSpinner} from '../containers/common/commonExport';

const CoverLoading = (props) => (
    <div className="printContainer">
        <div className={'printOverlay coverOverlay ' + (props.coverStatus === true ? '' : 'hidden')}></div>
        {/* <div className={'printProgress coverOverlayContainer ' + (props.coverStatus ? '' : 'hidden')}>
            <KeolisSpinner />
        </div> */}
    </div>
);

export default CoverLoading;